import { api } from 'modules/global/adapters';
import { revokeReleaseRightQueryKeys } from './queryKeys';
import { useQuery } from '@tanstack/react-query';
import { GetContainersByShippingAgentParams } from 'modules/global/adapters/crpAPI';
import { LABEL } from 'theme/constants';

export const useGetContainersByShippingAgent = (
  shippingParams: GetContainersByShippingAgentParams
) => {
  const isSearchEntered =
    Boolean(
      shippingParams.shippingAgentNxtEntityId &&
        shippingParams.shippingAgentNxtEntityId !== LABEL.UNKNOWN
    ) ||
    Boolean(shippingParams.equipmentNumber) ||
    Boolean(shippingParams.billOfLadingNumber);

  shippingParams.shippingAgentNxtEntityId =
    shippingParams.shippingAgentNxtEntityId === LABEL.UNKNOWN
      ? ''
      : shippingParams.shippingAgentNxtEntityId;

  return useQuery(
    revokeReleaseRightQueryKeys.containersForUpdate(shippingParams),
    () => api.containers.getContainersForRevokeByShippingAgentParams(shippingParams),
    {
      enabled: isSearchEntered,
    }
  );
};
